import React, { useState, useEffect } from 'react';

// Define your styles here
const styles = {
  container: { display: 'flex', flexDirection: 'column', height: '100vh' },
  header: { display: 'flex', justifyContent: 'space-between', padding: '10px', background: '#f5f5f5' },
  headerLeft: { display: 'flex' },
  headerCenter: { display: 'flex' },
  headerRight: { display: 'flex' },
  button: { margin: '0 5px', padding: '10px' },
  mainContent: { flex: '1', display: 'flex' },
  sidebar: { width: '30%', padding: '20px', background: '#eaeaea' },
  itemList: { marginTop: '20px' },
  item: { padding: '10px', cursor: 'pointer', backgroundColor: '#fff', marginBottom: '5px', borderRadius: '4px' },
  contactBox: { width: '70%', padding: '20px' },
};

const App = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  // Updated buttonIds to include direction
  const buttonIds = [
    { id: 'button1', direction: 'bottom' },
    { id: 'button2', direction: 'bottom' },
    { id: 'button3', direction: 'bottom' },
    { id: 'item1', direction: 'right' , click:true},
    { id: 'item2', direction: 'right' },
  ];



  const startTour = () => {
    // Create a new script element to hold the Vanilla JS code
    const script = document.createElement('script');
    script.innerHTML = `
      let currentStep = 0;
      let buttons = [];
      let overlay, tooltip;

      function initializeTour(buttonData) {
        buttons = buttonData;
        currentStep = 0;
        createOverlay();
        highlightButton();
      }

      function createOverlay() {
        overlay = document.createElement('div');
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.4)';
        overlay.style.zIndex = '9999';
        overlay.style.display = 'flex';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        document.body.appendChild(overlay);
        
        tooltip = document.createElement('div');
        tooltip.style.backgroundColor = '#fff';
        tooltip.style.padding = '20px';
        tooltip.style.borderRadius = '8px';
        tooltip.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.2)';
        tooltip.style.position = 'absolute';
        tooltip.style.zIndex = '10000';
        overlay.appendChild(tooltip);
        
        const nextButton = document.createElement('button');
        nextButton.textContent = currentStep === buttons.length - 1 ? 'Finish Tour' : 'Next';
        nextButton.style.marginTop = '10px';
        nextButton.onclick = nextTourStep;

        tooltip.appendChild(document.createElement('p')).innerText = \`This is \${buttons[currentStep].id}\`;
        tooltip.appendChild(nextButton);

        positionTooltip(buttons[currentStep]);
      }

      function highlightButton() {
        const button = document.getElementById(buttons[currentStep].id);
        if (button) {
          button.style.backgroundColor = '#ffeb3b'; // Highlight color
          button.style.border = '2px solid #4CAF50'; // Optional border
          if (buttons[currentStep].click) {
            button.click(); 
          }
        }
      }

      function positionTooltip(buttonData) {
        const button = document.getElementById(buttonData.id);
        if (button) {
          const rect = button.getBoundingClientRect();
          if (buttonData.direction === 'bottom') {
            tooltip.style.top = rect.bottom + window.scrollY + 'px';
            tooltip.style.left = rect.left + (rect.width / 2) + 'px';
            tooltip.style.transform = 'translateX(-50%)';
          } else if (buttonData.direction === 'right') {
            tooltip.style.top = rect.top + window.scrollY + 'px';
            tooltip.style.left = rect.right + 'px';
          }
        } else {
          alert(\`Button \${buttonData.id} not found\`);
        }
      }

      function nextTourStep() {
        if (currentStep < buttons.length - 1) {
          const button = document.getElementById(buttons[currentStep].id);
          if (button) {
            button.style.backgroundColor = ''; // Reset color
            button.style.border = ''; // Reset border
          }
          currentStep++;
          highlightButton();
          tooltip.querySelector('p').innerText = \`This is \${buttons[currentStep].id}\`;
          const nextButton = tooltip.querySelector('button');
          nextButton.textContent = currentStep === buttons.length - 1 ? 'Finish Tour' : 'Next';
          positionTooltip(buttons[currentStep]);
        } else {
          endTour();
        }
      }

      function endTour() {
        const button = document.getElementById(buttons[currentStep].id);
        if (button) {
          button.style.backgroundColor = ''; // Reset color
          button.style.border = ''; // Reset border
        }
        overlay.remove();
      }

      initializeTour(${JSON.stringify(buttonIds)});
    `;


    document.body.appendChild(script);

    // Cleanup script when the tour ends
    const cleanupScript = () => {
      document.body.removeChild(script);
    };

    const endTour = () => {
      cleanupScript();
      alert("Tour ended.");
    };

    // Make sure to call endTour when appropriate (for example, if you want to end it when clicking on the overlay)
    script.innerHTML += '\noverlay.onclick = endTour;';
  };

  useEffect(() => {
    // Add event listener for the Take A Tour button
    const takeATourButton = document.getElementById('take-a-tour-button');
    if (takeATourButton) {
      takeATourButton.addEventListener('click', startTour);
    }

    // Cleanup listener on component unmount
    return () => {
      if (takeATourButton) {
        takeATourButton.removeEventListener('click', startTour);
      }
    };
  }, []);


  const itemContent = {
    item1: "Details for Item 1: This item is related to X.",
    item2: "Details for Item 2: This item is focused on Y.",
    item3: "Details for Item 3: This item explores Z.",
    item4: "Details for Item 4: Additional information about W.",
    item5: "Details for Item 5: Insights on topic V."
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerLeft}>
          {['Button 1', 'Button 2', 'Button 3'].map((label, index) => (
            <button
              key={index}
              id={`button${index + 1}`}
              style={styles.button}
            >
              {label}
            </button>
          ))}
        </div>

        <div style={styles.headerCenter}>
          <button style={styles.button} id="take-a-tour-button">Take A Tour</button>
          <button style={styles.button}>Button 4</button>
        </div>

        <div style={styles.headerRight}>
          <button style={styles.button}>Button 5</button>
          <button style={styles.button}>Button 6</button>
          <button style={styles.button}>Button 7</button>
          <button style={styles.button}>Button 8</button>
        </div>
      </header>

      {/* Main Content */}
      <div style={styles.mainContent}>
        {/* Left Sidebar */}
        <div style={styles.sidebar}>
          <h2>Items</h2>
          <div style={styles.itemList}>
            {['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'].map((item, index) => (
              <div
                key={index}
                style={styles.item}
                id={`item${index + 1}`}
                onClick={() => setSelectedItem(`item${index + 1}`)}
              >
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* Right Content */}
        <div style={styles.contactBox}>
          <h2>Contact Box</h2>
          <p>This is a contact box where you can place any information you like.</p>
          {selectedItem && <p>{itemContent[selectedItem]}</p>}
        </div>
      </div>
    </div>
  );
};

export default App;
